import forEach from 'lodash/forEach';

import type { AppData, MaintenanceReminderDataType } from '../types/app_data';
import type { UpdateMaintenanceRemindersCarInput } from '../apollo/graphql/update_maintenance_reminders.mutation';
import type { SearchPolicyCar } from '../types/policy';

/**
 * Get maintenance reminder input cars for updateMaintenanceReminders mutation
 */
export const getUpdateMaintenanceRemindersInputCars = ({
  cars,
  maintenanceReminderData,
  MaintenanceReminderSettledCars,
}: {
  cars: SearchPolicyCar[] | undefined;
  maintenanceReminderData: Record<string, MaintenanceReminderDataType> | undefined;
  MaintenanceReminderSettledCars: Set<string> | undefined;
}): UpdateMaintenanceRemindersCarInput[] => {
  const inputCars: UpdateMaintenanceRemindersCarInput[] = [];
  forEach(cars, (car) => {
    try {
      atob(car.id);
    } catch {
      // if the car id could not be decoded, it is a temp uuid, so we should skip it
      return;
    }
    const isMaintenanceReminderSettled = MaintenanceReminderSettledCars?.has(car.id);
    const mrData = isMaintenanceReminderSettled ? maintenanceReminderData?.[car.id] : undefined;
    if (!mrData) return;
    inputCars.push({
      id: car.id,
      maintenanceReminderConfig: {
        oilType: mrData.oilType?.submitValue,
        oilChangeLastCompletedTime: mrData.oilChangeLastCompletedTime?.submitValue,
        tireRotatedLastCompletedTime: mrData.tireRotatedLastCompletedTime?.submitValue || '',
        brakePadsLastCompletedTime: mrData.brakePadsLastCompletedTime?.submitValue || '',
      },
    });
  });
  return inputCars;
};

/**
 * Check if the maintenance reminder setup should be shown.
 */
export const shouldShowMaintenanceReminderSetup = (appData: AppData): boolean => {
  return !!appData.maintenanceAccepted;
};

/**
 *
 */
export const getMaintenanceReminderSetupCarInfo = (car: SearchPolicyCar): string =>
  `${car.year} ${car.make} ${car.model}`;
